<template>
    <DashboardPage/>
</template>

<script>
// @ is an alias to /src
import DashboardPage from '@/components/DashboardPage.vue'

export default {
  name: 'DashboardView',
  components: {
    DashboardPage
  }
}
</script>